// The enum lives here, away from the component, so ActivityInfoIcon can use it
// without importing ActivityInfo -- which imports ActivityInfoIcon right back.
export enum ActivityType {
    MEDITATION = 'MEDITATION',
    BREATHING = 'BREATHING',
    TOOLING = 'TOOLING',
    THINKING = 'THINKING',
    ACTION = 'ACTION',
    JOURNALING = 'JOURNALING',
    WEBINAR = 'WEBINAR',
    STORY = 'STORY',
    LESSON = 'LESSON',
    SELF_ASSESSMENT = 'SELF_ASSESSMENT',
}
